export type P2FormData = {
    mandate: string;
    legal_instruments: { norm: string; provision: string }[];
    org_structure: string;
    highlighted_entities: string[];
    financial_years: { year: string; amount: string; growth: string }[];
    financial_significance: string[];
    process_steps: string;
    control_points: { process: string; risk: string; control: string }[];
    systems: { name: string; info: string }[];
    tech_controls: { control: string; year: string; purpose: string }[];
    cost_profile: { period: string; rate: string; context: string }[];
    milestones: { event: string; year: string; significance: string; flag: string }[];
    critical_risks_preview: { area: string; dimension: string; cluster: string }[];
    leakage_vectors: { vector: string; description: string; evidence: string; severity: string }[];
    swot: {
        strengths: string[];
        weaknesses: string[];
        opportunities: string[];
        threats: string[];
    };
};

export function defaultP2FormData(): P2FormData {
    return {
        mandate: "",
        legal_instruments: [],
        org_structure: "",
        highlighted_entities: [],
        financial_years: [],
        financial_significance: [],
        process_steps: "",
        control_points: [],
        systems: [],
        tech_controls: [],
        cost_profile: [],
        milestones: [],
        critical_risks_preview: [],
        leakage_vectors: [],
        swot: { strengths: [], weaknesses: [], opportunities: [], threats: [] },
    };
}
